import { useEffect, useState } from 'react';

import type { GetArticlesToFetchArgs, UseFetchDeferredProductProps } from '../components/types';

const countArticlesToFetch = ({
  totalCount,
  page,
  pageSize,
  initialPageSize,
  hasFetchedDeferred,
}: GetArticlesToFetchArgs) => {
  if (!initialPageSize || hasFetchedDeferred) {
    return 0;
  }

  const hasArticlesToFetch = totalCount > page * pageSize + initialPageSize;
  if (initialPageSize && pageSize > initialPageSize && hasArticlesToFetch) {
    return pageSize - initialPageSize;
  }

  return 0;
};

export const useFetchDeferredProducts = ({
  fetchProducts,
  appendArticles,
  offset,
  initialPageSize,
  pageSize,
  page,
  totalCount,
  shouldFetch,
}: UseFetchDeferredProductProps) => {
  const [hasFetchedDeferred, setHasFetchedDeferred] = useState(false);
  const articlesToFetch = countArticlesToFetch({
    totalCount,
    page,
    pageSize,
    initialPageSize: initialPageSize ?? null,
    hasFetchedDeferred,
  });

  useEffect(() => {
    if (articlesToFetch > 0 && shouldFetch) {
      (async () => {
        try {
          const loadedArticles = await fetchProducts(offset - articlesToFetch, articlesToFetch);
          appendArticles(loadedArticles);
        } catch {
          // Ignore error, as we don't have UX behavior for that
        } finally {
          setHasFetchedDeferred(true);
        }
      })();
    }
  }, [shouldFetch]);

  return { hasFetchedDeferred, articlesToFetch };
};
